import { CreditCardChipIcon } from './CreditCardChipIcon';

/**
 * author: Jeff Anders
 * id B116C077-E89C-4079-8CEB-7946D054613D
 * name credit-card-chip
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-chip.svg
 * tags
 * - Banking 
 */
export const CreditCardIccChipIcon = CreditCardChipIcon;
export default CreditCardIccChipIcon